function exoDebounce(fn, wait) {
  var t;
  return function () {
    var ctx = this;
    var args = arguments;
    clearTimeout(t);
    t = setTimeout(function () {
      fn.apply(ctx, args);
    }, wait);
  };
}

class ExoYoutubeShorts extends HTMLElement {
  connectedCallback() {
    this.scroller = this.querySelector('.exo-shorts__scroller');
    if (!this.scroller) return;
    this.dotsEl = this.querySelector('.exo-shorts__dots');
    this.prevBtn = this.querySelector('[data-exo-dir="prev"]');
    this.nextBtn = this.querySelector('[data-exo-dir="next"]');

    this.isDragging = false;
    this.moved = false;
    this.startX = 0;
    this.startScroll = 0;
    this.pages = 1;

    this.onPointerMove = this.onPointerMove.bind(this);
    this.onPointerUp = this.onPointerUp.bind(this);

    this.scroller.addEventListener('click', this.onClick.bind(this));
    this.scroller.addEventListener('pointerdown', this.onPointerDown.bind(this));

    if (this.prevBtn) this.prevBtn.addEventListener('click', this.page.bind(this, -1));
    if (this.nextBtn) this.nextBtn.addEventListener('click', this.page.bind(this, 1));

    this.onScroll = this.onScroll.bind(this);
    this.scroller.addEventListener('scroll', this.onScroll, { passive: true });

    this.build = this.build.bind(this);
    this._onResize = exoDebounce(this.build, 150);
    window.addEventListener('resize', this._onResize);

    this.build();
    if (document.readyState !== 'complete') {
      window.addEventListener('load', this.build);
    }
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this._onResize);
    window.removeEventListener('load', this.build);
    this.stopDragTracking();
  }

  /* ── 페이징 ── */
  page(dir) {
    this.scroller.scrollBy({ left: dir * this.scroller.clientWidth, behavior: 'smooth' });
  }

  build() {
    var cw = this.scroller.clientWidth;
    if (!cw) return;
    var max = this.scroller.scrollWidth - cw;
    var paged = max > 2;
    this.pages = paged ? Math.max(2, Math.ceil(this.scroller.scrollWidth / cw)) : 1;
    this.classList.toggle('is-paged', paged);

    if (this.dotsEl) {
      this.dotsEl.innerHTML = '';
      if (paged) {
        for (var i = 0; i < this.pages; i++) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'exo-shorts__dot';
          dot.setAttribute('aria-label', i + 1 + ' / ' + this.pages);
          dot.dataset.page = i;
          dot.addEventListener('click', this.goTo.bind(this, i));
          this.dotsEl.appendChild(dot);
        }
      }
    }
    this.update();
  }

  goTo(index) {
    var max = this.scroller.scrollWidth - this.scroller.clientWidth;
    var left = this.pages > 1 ? (index / (this.pages - 1)) * max : 0;
    this.scroller.scrollTo({ left: left, behavior: 'smooth' });
  }

  onScroll() {
    if (this._raf) return;
    var self = this;
    this._raf = requestAnimationFrame(function () {
      self._raf = null;
      self.update();
    });
  }

  update() {
    var cw = this.scroller.clientWidth;
    if (!cw) return;
    var max = this.scroller.scrollWidth - cw;
    var idx = 0;
    if (max > 0 && this.pages > 1) {
      idx = Math.round((this.scroller.scrollLeft / max) * (this.pages - 1));
    }
    if (idx < 0) idx = 0;
    if (idx > this.pages - 1) idx = this.pages - 1;

    if (this.dotsEl) {
      var dots = this.dotsEl.children;
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('is-active', i === idx);
      }
    }

    var atStart = this.scroller.scrollLeft <= 2;
    var atEnd = this.scroller.scrollLeft >= max - 2;
    if (this.prevBtn) this.prevBtn.disabled = atStart;
    if (this.nextBtn) this.nextBtn.disabled = atEnd;
  }

  /* ── 클릭 재생 (드래그와 구분) ── */
  onClick(event) {
    if (this.moved) {
      this.moved = false;
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    var target = event.target;
    var card = target && target.closest ? target.closest('.exo-shorts__card') : null;
    if (!card) return;

    var videoId = card.dataset.videoId;
    if (!videoId) return;

    var iframe = document.createElement('iframe');
    iframe.className = 'exo-shorts__iframe';
    iframe.src =
      'https://www.youtube.com/embed/' +
      encodeURIComponent(videoId) +
      '?autoplay=1&playsinline=1&rel=0';
    iframe.title = card.getAttribute('aria-label') || 'YouTube Shorts';
    iframe.setAttribute(
      'allow',
      'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
    );
    iframe.allowFullscreen = true;

    // <button> の中に <iframe> を置くのは不正なマークアップなので、ボタンごと差し替える
    var media = document.createElement('span');
    media.className = 'exo-shorts__media';
    media.appendChild(iframe);
    card.replaceWith(media);
  }

  /* ── 마우스 드래그 스크롤 ──
     setPointerCapture は click の発火先を捕捉要素に付け替えてしまい、
     カードのクリック判定が壊れる。代わりに window で追跡する。 */
  onPointerDown(event) {
    if (event.pointerType === 'touch' || event.button !== 0) return;
    this.isDragging = true;
    this.moved = false;
    this.startX = event.clientX;
    this.startScroll = this.scroller.scrollLeft;
    this.scroller.classList.add('is-dragging');

    window.addEventListener('pointermove', this.onPointerMove);
    window.addEventListener('pointerup', this.onPointerUp);
    window.addEventListener('pointercancel', this.onPointerUp);
  }

  onPointerMove(event) {
    if (!this.isDragging) return;
    var dx = event.clientX - this.startX;
    if (Math.abs(dx) > 4) this.moved = true;
    this.scroller.scrollLeft = this.startScroll - dx;
  }

  onPointerUp() {
    if (!this.isDragging) return;
    this.isDragging = false;
    this.scroller.classList.remove('is-dragging');
    this.stopDragTracking();
  }

  stopDragTracking() {
    window.removeEventListener('pointermove', this.onPointerMove);
    window.removeEventListener('pointerup', this.onPointerUp);
    window.removeEventListener('pointercancel', this.onPointerUp);
  }
}

if (!customElements.get('exo-youtube-shorts')) {
  customElements.define('exo-youtube-shorts', ExoYoutubeShorts);
}
